import { Popper, Tab, Tabs, Typography } from "@mui/material";
import { EducationalCalendar, Headline, Layout, SearchInput } from "../../components";
import { ToturialController } from "../../controllers";
import Box from '@mui/material/Box';
import { Arrowleft, Cancel, Hamburgermenu } from "../../../assets";
import { Helmet } from "react-helmet-async";
interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}
function a11yProps(index: number) {
    return {
        id: `vertical-tab-${index}`,
        'aria-controls': `vertical-tabpanel-${index}`,
    };
}
class Toturial extends ToturialController {
    componentDidMount() {
        window.scrollTo(0, 0);
        this.getCategoriesList();

    }
    render() {
        const { tabValue, categoriesList, subcategories , loading , categorySelected} = this.state;
        function TabPanel(props: TabPanelProps) {
            const { children, value, index, ...other } = props;


            return (
                <div
                    role="tabpanel"
                    hidden={value !== index}
                    id={`vertical-tabpanel-${index}`}
                    aria-labelledby={`vertical-tab-${index}`}
                    {...other}
                >
                    {value === index && (
                        <Box sx={{ p: 3 }}>
                            <Typography>{children}</Typography>
                        </Box>
                    )}
                </div>
            );
        }
        return (
            <Layout title="اموزشات">
                <Helmet>
        <title>اموزشات | بیمه زندگی هامرز</title>
      </Helmet>
 
                <>
                <SearchInput loadingContent={loading} buttonTitle="جستجو" placeholder="دنبال چه موضوعی میگردی ؟" str={this.state.str} search={this.search} onClick={()=>{}}/>
                <div className="toturial scrollbar">
                    <div className="toturial-tab">
                        <Tabs
                            orientation="vertical"
                            variant="scrollable"
                            value={tabValue}
                            onChange={this.handleChange}
                            aria-label={`simple-tabpanel-${tabValue}`}
                            id={`simple-tab-${tabValue}`}
                            key={`simple-tab-${tabValue}`}
                            // sx={{position:"fixed"}}
                        >

                            {loading ? <div className="toturial-tab-item content-loading"></div> 
                            :
                            <>
                            {categoriesList?.map((item, index) => {
                                return (
                                    <Tab key={index} className="toturial-tab-item" label={item?.title} {...a11yProps(item?.id)} onClick={() => this.getsubCategories(item)} />
                                    )
                                })}
                            </>
                            }
                        </Tabs>
                        <div className="toturial-tab-content">
                            <Headline myStyle="hide-desktop" title={this.state.headLineTitle} />


                            {loading ?

<>
  <div className="w-100 toturial-loading content-loading"></div>
</>

:

<>
                            {subcategories?.map((item, index) => {
                                return (
                                    <TabPanel value={item.category} index={item.category} key={index}>
                                        <EducationalCalendar  title={item?.subject}
                                         date={new Date(item?.date).toLocaleDateString('fa-IR')} time={new Date(item?.date).toLocaleTimeString('fa-IR')} badge={item?.label}
                                            description={item?.description}
                                            btnTitle="مشاهده"
                                            files={item?.files}
                                            links={item?.links}
                                            img={categorySelected?.picture}
                                            />
                                    </TabPanel>
                                )
                            })}

</>

}
                        </div>

                    </div>
                    <div className="hide-desktop menu-btn" aria-describedby={this.id} onClick={this.handleClick}>
                        {this.state.open ?
                            <Cancel color="#ffffff" />
                            :
                            <img src={Hamburgermenu} alt="هامرز" />
                        }
                    </div>
                    <Popper id={this.id} open={this.state.open} anchorEl={this.state.anchorEl} placement="top-start" className="toturial-popover">
                        <div className="toturial-popover-content ">
                        {categoriesList?.map((item, index) => {
                                return (
                                    <div className="toturial-popover-content-item" key={index} onClick={(event) => this.handleClose(event,item)}> <span>
                               {item?.title}
                            </span> <Arrowleft /> </div>
                                )
                            })}
                        </div>
                    </Popper>

                </div>
                </>
            </Layout>
        )
    }
}

export default Toturial;